import { call, put } from 'redux-saga/effects';

import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { EditConnectionAction } from '~src/datasource/dataConnection/actions/EditConnectionAction';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { openFlowAnalyticsExtensionDialog } from '../components/openFlowAnalyticsExtensionDialog';
import { isFlowAnalyticsExtensionRow } from '../models/FlowAnalyticsExtensionRow';

export function* handleEditFlowConnectionAction(action: EditConnectionAction) {
  const extension = action.dataConnectionsOrSources.find(isFlowAnalyticsExtensionRow);
  if (!extension || action.dataConnectionsOrSources.length !== 1 || !extension.analyticsExtensionFlowLuid || !extension.analyticsExtensionConnection.canUpdate) {
    return;
  }
  try {
    yield call(openFlowAnalyticsExtensionDialog, extension.analyticsExtensionConnection, extension.analyticsExtensionFlowLuid);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
